import React from 'react';

import {browserHistory, Route, Router} from 'react-router';

import {
  DocNameBreadcrumb,
  EditDocBreadcrumb,
} from 'app/components/general/breadcrumbs';
import {DemoBasePage} from 'app/demo/components/DemoBasePage';
import {DemoProcedureEditPage} from 'app/demo/components/DemoProcedureEditPage';
import {RedirectToProcedureVersionPage} from 'app/demo/components/RedirectToProcedureVersionPage';
import {SPFrame} from 'app/general/structures/SPFrame';
import {ProceduresDashboardBreadcrumb} from 'app/procedures/components/ProceduresDashboard';

interface Props {
  history?: any;
}

export const RootRouter = ({history = browserHistory}: Props): JSX.Element => (
  <Router history={history}>
    <Route component={DemoBasePage}>
      <Route component={SPFrame}>
        <Route props={{breadcrumb: ProceduresDashboardBreadcrumb}}>
          <Route props={{breadcrumb: DocNameBreadcrumb}}>
            <Route props={{breadcrumb: EditDocBreadcrumb}}>
              <Route
                path="/demo/procedures/:hashid/(:slug)/version/:versionid/*"
                component={DemoProcedureEditPage}
              />
              <Route path="/*" component={RedirectToProcedureVersionPage} />
            </Route>
          </Route>
        </Route>
      </Route>
    </Route>
  </Router>
);
